import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Phone, Star, Download, FileSpreadsheet } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, apiError } from "@/lib/api";

export default function CustomersTab() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/admin/customers").then((r) => setItems(r.data)); }, []);

  const download = async (fmt) => {
    try {
      const r = await api.get("/admin/customers/export", { params: { fmt }, responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement("a");
      a.href = url; a.download = `customers.${fmt === "xlsx" ? "xlsx" : "csv"}`; a.click();
      URL.revokeObjectURL(url);
      toast.success("Customer data downloaded");
    } catch (e) { toast.error(apiError(e)); }
  };

  if (!items) return <Loader2 className="animate-spin text-purple-400" />;
  return (
    <div>
      <div className="flex items-center justify-between flex-wrap gap-3 mb-5">
        <p className="text-sm text-slate-400">{items.length} customer(s)</p>
        <div className="flex gap-2">
          <Button size="sm" onClick={() => download("xlsx")} data-testid="export-customers-xlsx" className="h-9 bg-emerald-600 hover:bg-emerald-500"><FileSpreadsheet size={14} /> Excel</Button>
          <Button size="sm" variant="outline" onClick={() => download("csv")} data-testid="export-customers-csv" className="h-9 border-purple-500/30 bg-transparent text-slate-200"><Download size={14} /> CSV</Button>
        </div>
      </div>
      {items.length === 0 ? <p className="text-slate-500 text-center py-10">No customers yet.</p> : (
        <div className="space-y-3">
          {items.map((c) => (
            <div key={c.mobile} className="glass rounded-2xl p-4 flex items-center justify-between" data-testid={`customer-${c.mobile}`}>
              <div>
                <p className="font-semibold flex items-center gap-2">{c.name}{c.total_bookings > 1 && <span className="text-[10px] px-2 py-0.5 rounded-full border border-amber-500/30 bg-amber-500/10 text-amber-300 flex items-center gap-1" data-testid={`returning-${c.mobile}`}><Star size={10} /> Returning</span>}</p>
                <a href={`tel:${c.mobile}`} className="text-sm text-slate-400"><Phone size={12} className="inline" /> {c.mobile}</a>
                <p className="text-xs text-slate-500 mt-0.5">Last booking: {c.last_booking}</p>
              </div>
              <div className="text-right">
                <p className="font-display text-lg font-bold text-emerald-400">₹{c.total_spent}</p>
                <p className="text-xs text-slate-400">{c.total_bookings} booking(s)</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
